// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import ScrollToTop from './components/ScrollToTop';   // ← add this import

// Services Pages
import AIServices from './components/AIServices';
import WebDevelopment from './components/WebDevelopment';
import MobileAppDevelopment from './components/MobileAppDevelopment';
import SoftwareConsulting from './components/SoftwareConsulting';
import ThirdPartyIntegration from './components/ThirdPartyIntegration';
import CustomDevelopment from './components/CustomDevelopment';
import EnterpriseApplication from './components/EnterpriseApplication';
import Energy from'./components/Energy';
import Construction from'./components/Construction';
import Warehouse from'./components/Warehouse';
import Manufacture from'./components/Manufacture';

// Industries Pages
import DigitalTransformation from "./components/DigitalTransformation";
import Logistics from "./components/Logistics";
import Healthcare from "./components/Healthcare";
import FinancialServices from "./components/FinancialServices";
import Education from "./components/Education";
import Hospitality from './components/Hospitality';
import Entertainment from './components/Entertainment';



// Company Pages
import OurAdvantages from './components/OurAdvantages';
import OurStory from './components/OurStory';
import PeopleOfLentera from './components/PeopleOfLentera';
import OurBrand from './components/OurBrand';
import Blogs from './components/Blogs';
// import Certification from './components/Certifications';
import SupportUs from './components/SupportUs';
import Careers from './components/Careers';
import Cookie from'./components/Cookie';
import Privacy from'./components/Privacy';
import Terms from'./components/Terms';
import Copyrights from'./components/Copyrights';
import OurStories from'./components/OurStories';

// Other Pages
import ContactUs from './components/ContactUs';

function App() {
  return (
    <Router>
      {/* ScrollToTop must be inside Router so it can access useLocation */}
      <ScrollToTop />           {/* ← add this line */}
      <Routes>
        <Route path="/" element={<Home />} />

        {/* Services */}
        
        <Route path="/services/ai-services/" element={<AIServices />} />
  <Route path="/services/web-development/" element={<WebDevelopment />} />
  <Route path="/services/mobile-app-development/" element={<MobileAppDevelopment />} />
  <Route path="/services/software-consulting/" element={<SoftwareConsulting />} />
  <Route path="/services/third-party-integration/" element={<ThirdPartyIntegration />} />
  <Route path="/services/custom-development/" element={<CustomDevelopment />} />
  <Route path="/services/enterprise-application/" element={<EnterpriseApplication />} />
  <Route path="/services/digital-transformation" element={<DigitalTransformation />} /> 


         <Route path="/industries/logistics/"  element={<Logistics />} />
         <Route path="/industries/healthcare/" element={<Healthcare  />} />
         <Route path="/industries/financial-services/" element={<FinancialServices />} />
         <Route path="/industries/healthcare/" element={<Healthcare />} />
         <Route path="/industries/education/" element={<Education />} />
  
  <Route path="/industries/hospitality/" element={<Hospitality />} />
  <Route path="/industries/entertainment/" element={<Entertainment />} />
  <Route path="/industries/energy/" element={<Energy />} />
  <Route path="/industries/construction/" element={<Construction />} />
  <Route path="/industries/warehouse/" element={<Warehouse />} />
  <Route path="/industries/manufacture/" element={<Manufacture />} />

  <Route path="/company/our-advantages/" element={<OurAdvantages />} />
  <Route path="/company/our-story/" element={<OurStory />} />
  <Route path="/company/our-stories/" element={<OurStories/>} />
  <Route path="/company/people-of-lentera/" element={<PeopleOfLentera />} />
  <Route path="/company/our-brand/" element={<OurBrand />} />
  <Route path="/company/careers/" element={<Careers />} />
  <Route path="/company/blogs/" element={<Blogs />} />
  {/* <Route path="/company/certifications/" element={<Certifications />} /> */}
  <Route path="/support-us" element={<SupportUs />} />
  <Route path="/cookie-policy/" element={<Cookie />} />
  <Route path="/privacy-policy/" element={<Privacy />} />
  <Route path="/terms-condition/" element={<Terms />} />
 <Route path="/copyright-information/" element={<Copyrights />} />
 <Route path="/our-stories/" element={<OurStories />} />
        {/* Other */}
        <Route path="/contact/" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;
